import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import React from "react";
import styles from "./ContactSuccess.module.css";
import { useNavigate } from "react-router-dom";

import "../../fonts/Futura-PT-Book.ttf";
const ContactSuccess = () => {
  const navigate = useNavigate();

  return (
    <>
      <Header />
      
      <div className={styles.main}>
        <div className={styles.headText}>
            <p>Contact Form</p>
            お問い合わせ
        </div>
        <div className={styles.box}>
          <div className={styles.box_text}>
          メールを送信完了しました。 
          </div>
          <div className={styles.box_text}>
          営業日以内にご連絡を致します。 
          </div>
          <div className={styles.box_text}>
          お問い合わせありがとうございました。 
          </div>
        </div>
        <div className={styles.button_main_div}>
          <button type="button" className={styles.button_main} onClick={() => navigate("/")} >Top</button>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default ContactSuccess;
